// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M69.691 48.617c0-.445-.093-.855-.28-1.23a3.328 3.328 0 0 0-.74-1.09L40.829 19.016c-.633-.61-1.406-.914-2.32-.914-.586 0-1.125.14-1.617.421a3.064 3.064 0 0 0-1.16 1.16c-.282.47-.422 1.008-.422 1.618 0 .867.304 1.629.914 2.285l25.593 25.031-25.593 25.031c-.61.657-.914 1.418-.914 2.286 0 .609.14 1.148.422 1.617.28.492.667.879 1.16 1.16a3.203 3.203 0 0 0 1.617.422c.914 0 1.687-.317 2.32-.95l27.844-27.246c.328-.328.574-.68.738-1.054.188-.399.281-.82.281-1.266Z"
			fill="#000"
		/>
	</svg>
);
export default ChevronRight;
